import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Title } from 'src/app/shared/models/title.model';
import { TitlesService } from '../../titles/titles.service';
import { Response } from 'src/app/shared/models/response.model';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-screen-gbp',
  templateUrl: './screen-gbp.component.html',
  styleUrls: ['./screen-gbp.component.scss']
})
export class ScreenGbpComponent implements OnInit {

  filterForm: FormGroup;
  offset: number;
  total: number;
  titles: Title[];
  isbn: string;

  private titlesSubscription: Subscription = null;
  private routeParamSubscription: Subscription = null;

  constructor(private formBuilder: FormBuilder,
    private loader: NgxSpinnerService,
    private titlesService: TitlesService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,) { }

  ngOnInit() {

    this.filterForm = this.formBuilder.group({
      mark: ['']
    });

    this.routeParamSubscription = this.route
      .params
      .subscribe(params => {
        this.isbn = JSON.parse(params['isbn']);

        console.log('isbn dentro de gbp' + this.isbn);

      });

    this.total = 0;
    this.titles = [];

    this.getTitlesGBP();

  }

  getTitlesGBP() {
    this.loader.show();

    this.titlesSubscription = this.titlesService.getTitlesByFilter(this.isbn, 1, 25).subscribe((result: Response) => {
      this.total = result.total;
      this.titles = result.items;
      this.loader.hide();

      if (this.titles.length === 0) {
        this.toastr.info('No se encontraron titulos en el banco seleccionado');
      }
    }, (error) => {
      this.loader.hide();
      console.error(error.message);
    });
  }

  gotoTitleDetail(row: Title): void {
    const currentStockId = this.filterForm.get('mark').value;
    this.router.navigate(['/titles/title-detail', { title: JSON.stringify(row), stock: JSON.stringify(currentStockId) }]);
  }
}
